import { useNavigate } from "react-router";

export const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="px-4 mt-2 pb-3">
      <div className="d-flex justify-content-center">
        <ul className="nav mt-2">
          <li className="nav-item">
            <a
              href="#"
              className="nav-link text-body-secondary"
              onClick={() => navigate("/")}
            >
              Home
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#"
              className="nav-link text-body-secondary"
              onClick={() => navigate("/help/general")}
            >
              Hilfe
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#"
              className="nav-link text-body-secondary"
              onClick={() => navigate("/imprint")}
            >
              Impressum
            </a>
          </li>
        </ul>
      </div>

      <div className="">
        <div className="copy d-flex justify-content-center">
          <hr style={{ width: "30px", margin: "0" }} />
        </div>
        <div className="copy d-flex justify-content-center mt-2">
          © 2025 BIK
          <span
            style={{
              display: "inline-block",
              width: "12px",
              height: "12px",
              background: "red",
              margin: "0 4px 0 4px",
            }}
          ></span>{" "}
          ASCHPURWIS + BEHRENS GmbH
        </div>
      </div>
    </footer>
  );
};
